import { render, staticRenderFns } from "./DistCont1.vue?vue&type=template&id=0cd791df&scoped=true&"
import script from "./DistCont1.vue?vue&type=script&lang=js&"
export * from "./DistCont1.vue?vue&type=script&lang=js&"
import style0 from "./DistCont1.vue?vue&type=style&index=0&id=0cd791df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd791df",
  null
  
)

export default component.exports